import React from 'react';
import {compose} from "redux";
import {withRouter} from "react-router";

import styles from './ConfirmModal.module.scss';

import {appendBasePath} from "../../../utils/nav.utils";

const ConfirmModal = ({ onClose, history }) => {
  return (
    <div>
      <div className={styles.title}>You didn't make any changes to your <span className={styles.noBreak}>Auto-RMD.</span></div>
      <div className={styles['button-container']}>
        <button
          id="edit-path-continue-editing"
          onClick={onClose}
          className={styles.stay}
        >
          Continue Editing
        </button>
        <button
          id="edit-path-return-to-dashboard"
          className={styles.leave}
          onClick={(e) => {
            onClose();
            history.push(appendBasePath("/"))
          }}
        >
          Return to the RMD dashboard
        </button>
      </div>
    </div>
  );
};

export default compose(withRouter)(ConfirmModal);
